import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { easepick } from '@easepick/core';
import { Core } from '@easepick/core/dist/core';
import { RangePlugin } from '@easepick/range-plugin';
import { IRangeDate } from '../models/graph-data.interface';
import { AmpPlugin } from '@easepick/amp-plugin';
import { Options, LabelType } from '@angular-slider/ngx-slider';
import { format } from 'date-fns';
import { PopoverController, ToastController } from '@ionic/angular';
@Component({
  selector: 'app-map-date-picker',
  templateUrl: './map-date-picker.component.html',
  styleUrls: ['./map-date-picker.component.scss'],
})
export class MapDatePickerComponent implements OnInit {

  @Input() showMenu!: boolean;
  @Input() timeRange!: boolean;
  @Input() timeMoment!: boolean;
  @Output() closeEvent = new EventEmitter<boolean>();
  @Output() rangeDateEvent = new EventEmitter<string>();
  @Output() minDateEvent = new EventEmitter<Date>();
  @Output() maxDateEvent = new EventEmitter<Date>();

  @Output() minDateEventRange = new EventEmitter<Date>();
  @Output() maxDateEventRange = new EventEmitter<Date>();

  @Input() minValue!: Date

  @Input() minValueRange: Date = new Date(
    new Date().getFullYear() - 1,
    new Date().getMonth(),
    new Date().getDate()
  );

 
  constructor(
    private popoverController: PopoverController,
    private toast: ToastController
  ) {}

  ngAfterViewInit(): void {
  }

  ngOnInit() {}

  setRangeDate(event: Date, type = 'end') {
    type == 'start' ? (this.minDateEventRange.emit(event)) : (this.maxDateEventRange.emit(event));
  }

  setTimeMomentDate(event: Date, type = 'end') {
    type == 'start' ? (this.minDateEvent.emit(event)) : (this.maxDateEvent.emit(event));
  }
 
  validateDate(date: Date): any {
    return !isNaN(date.getTime())
  }

}
